import { render, staticRenderFns } from "./addHosm.vue?vue&type=template&id=73c027b6&scoped=true"
import script from "./addHosm.vue?vue&type=script&lang=js"
export * from "./addHosm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c027b6",
  null
  
)

export default component.exports